import initialState from './initialState';
import { FETCH_USER_DATA, RECEIVE_USER_DATA, CLEAR_USER_DATA } from '../actions/actionTypes';
import { trackUser } from '@forwardfinancing/analytics-frontend-library';

export default function user(state = initialState.user, action) {
  switch (action.type) {
    case FETCH_USER_DATA:
      return action;
    case RECEIVE_USER_DATA:

      // analytics
      trackUser(action.user);

      return action.user;
    case CLEAR_USER_DATA:
      return initialState.user;
    default:
      return state;
  }
}
